import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '@abp/ng.core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { DepartmentSelectorComponent } from './components/department-selector/department-selector.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { DepartmentTreeComponent } from './components/department-tree/department-tree.component';

export { DepartmentSelectorComponent } from './components/department-selector/department-selector.component';
export { DepartmentTreeComponent } from './components/department-tree/department-tree.component';

@NgModule({
  declarations: [DepartmentSelectorComponent, DepartmentTreeComponent],
  imports: [CoreModule, NgbTooltipModule, ReactiveFormsModule, FormsModule, CommonModule, NgSelectModule],
  exports: [DepartmentSelectorComponent, DepartmentTreeComponent],
})
export class DepartmentSelectorModule {}
